import * as Schema from "effect/Schema";

// Arc TOOL (GOALS-TOOLS-SIGNALS #tool3–#tool6): the tool reach doors' shapes.
// Reach is eligibility, never injection; these are projections of the World
// authority's fold, never a second registry.
export const ToolReachMode = Schema.Literals(["off", "rooms", "everywhere"]);
export type ToolReachMode = typeof ToolReachMode.Type;
export const ToolReachScope = Schema.Literals(["platform", "world", "actor"]);
export type ToolReachScope = typeof ToolReachScope.Type;

const Page = Schema.Struct({ cursor: Schema.NullOr(Schema.String), isDone: Schema.Boolean });
export const ToolReachRow = Schema.Struct({
  mode: Schema.NullOr(ToolReachMode),
  revision: Schema.Int,
});
export type ToolReachRow = typeof ToolReachRow.Type;
const BundleRow = Schema.Struct({
  bundleKey: Schema.String,
  name: Schema.String,
  mode: Schema.NullOr(ToolReachMode),
  revision: Schema.Int,
});
const Level = Schema.Struct({ tool: ToolReachRow, bundles: Schema.Array(BundleRow) });

export const ToolReachCatalogTool = Schema.Struct({
  name: Schema.String,
  effective: ToolReachMode,
  governingScope: Schema.String,
  rows: Schema.Struct({
    actor: Schema.optionalKey(Level),
    world: Schema.optionalKey(Level),
    platform: Schema.optionalKey(Level),
  }),
});
export type ToolReachCatalogTool = typeof ToolReachCatalogTool.Type;

export const ToolReachCatalogView = Schema.Struct({
  schemaVersion: Schema.Literal("tool-access-catalog-v1"),
  operatorWorldKey: Schema.String,
  world: Schema.Struct({ worldKey: Schema.String, name: Schema.String }),
  subject: Schema.NullOr(
    Schema.Struct({ actorId: Schema.String, actorKey: Schema.String, displayName: Schema.String }),
  ),
  tools: Schema.Array(ToolReachCatalogTool),
  total: Schema.Int,
  page: Page,
});
export type ToolReachCatalogView = typeof ToolReachCatalogView.Type;

export const ToolBundle = Schema.Struct({
  bundleKey: Schema.String,
  name: Schema.String,
  status: Schema.Literals(["active", "retired"]),
  toolNames: Schema.Array(Schema.String),
  revision: Schema.Int,
});
export type ToolBundle = typeof ToolBundle.Type;
export const ToolBundlesView = Schema.Struct({
  schemaVersion: Schema.Literal("tool-access-bundles-v1"),
  operatorWorldKey: Schema.String,
  bundles: Schema.Array(ToolBundle),
  page: Page,
});
export type ToolBundlesView = typeof ToolBundlesView.Type;

export const ToolReachWorldsView = Schema.Struct({
  schemaVersion: Schema.Literal("tool-access-worlds-v1"),
  operatorWorldKey: Schema.String,
  worlds: Schema.Array(
    Schema.Struct({
      worldKey: Schema.String,
      name: Schema.String,
      bundles: Schema.Array(
        Schema.Struct({
          bundleKey: Schema.String,
          name: Schema.String,
          effective: ToolReachMode,
          governingScope: Schema.Literals(["world", "platform", "default"]),
          world: ToolReachRow,
          platform: ToolReachRow,
        }),
      ),
    }),
  ),
  page: Page,
});
export type ToolReachWorldsView = typeof ToolReachWorldsView.Type;

export const ToolReachRead = Schema.Struct({
  view: Schema.optionalKey(Schema.Literals(["catalog", "bundles", "worlds"])),
  targetWorldKey: Schema.optionalKey(Schema.String),
  subjectActorId: Schema.optionalKey(Schema.String),
  bundleKey: Schema.optionalKey(Schema.String),
  query: Schema.optionalKey(Schema.String),
  cursor: Schema.optionalKey(Schema.NullOr(Schema.String)),
  limit: Schema.optionalKey(Schema.Int),
});
export type ToolReachRead = typeof ToolReachRead.Type;

export const SetToolReach = Schema.Struct({
  scope: ToolReachScope,
  targetWorldKey: Schema.optionalKey(Schema.String),
  subjectActorId: Schema.optionalKey(Schema.String),
  targetKind: Schema.Literals(["tool", "bundle"]),
  targetKey: Schema.String,
  mode: Schema.NullOr(ToolReachMode),
  expectedRevision: Schema.Int,
  requestKey: Schema.String,
});
export type SetToolReach = typeof SetToolReach.Type;

export const SetToolBundle = Schema.Struct({
  bundleKey: Schema.String,
  name: Schema.String,
  toolNames: Schema.Array(Schema.String),
  status: Schema.Literals(["active", "retired"]),
  expectedRevision: Schema.Int,
  requestKey: Schema.String,
});
export type SetToolBundle = typeof SetToolBundle.Type;
